import React, { useEffect, useState } from "react";
import { Get } from "../../http/httpVerbs";
import { useAuthStore } from "../../store/useAuthStore";
import { Loader } from "../ui/Loader";
import { CampanhasLines } from "./CampanhasLines";
import "./campanhas.css";
import { useErrorStore } from "../../store/useErrorStore";

const useCampanhas = (creatorId) => {
    const [campanhas, setCampanhas] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const showError = useErrorStore((state) => state.showError);

    useEffect(() => {
        const fetchCampanhas = async () => {
            setIsLoading(true);

            try {
                const dataCampanhas = await Get(
                    `${process.env.REACT_APP_API_URL}/campanhas/?creator=${creatorId}&noFilter=true`,
                );
                setCampanhas(dataCampanhas);
            } catch (error) {
                showError(error);
            } finally {
                setIsLoading(false);
            }
        };

        if (creatorId) fetchCampanhas();
    }, [creatorId, showError]);

    return { campanhas, isLoading };
};

export const Campanhas = () => {
    const creator = useAuthStore((state) => state.creator);
    const { campanhas, isLoading } = useCampanhas(creator?.id);

    if (isLoading) return <Loader />;

    return (
        <>
            <CampanhasLines campanhas={campanhas} creator={creator} />
        </>
    );
};
